export const ONBOARD = 'Onboarding Information';
export const GHG_EMISSION_ACTIVITIES = 'GHG Emission Activities';
export const EHPRD = 'Emission Hotspots and Potential Reduction Directions';
export const CNP = 'Carbon Neutral Planning';
export const EXTERNAL_SUPPORT = 'External Support';
export const REPORT_DECLERATION = 'Report Declaration';
export const USER_MANAGEMENT = 'User Management';
export const COMPANY_MANAGEMENT = 'Company Management';
